module.exports = __webpack_public_path__ + "static/media/viure-als-pirineus-402px.7268f6b5.png";